import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

type PageKey = 'timetable' | 'crmKanban' | 'taskTracker'

export const PATHS_BY_KEY: Record<PageKey, string> = {
  timetable: '/timetable',
  crmKanban: '/crm-kanban',
  taskTracker: '/task-tracker',
}


export const useIsCurrentPage = (page: PageKey) => {
  const { pathname } = useLocation()

  const path = useMemo(() => {
    return PATHS_BY_KEY[page]
  }, [page])

  if (!path) return false

  return pathname === path || pathname.startsWith(`${path}/`)
}
